import React  , { useContext  } from 'react';  

import AppContext from 'js/Contexts/App.js';

const Anchor = (props) => {
    let newProps = {...props};
    delete newProps.checkNewTabRequestFirst; 

    const appContext = useContext(AppContext);

    const onClick = (e) => {
        if( props.checkNewTabRequestFirst ){
            checkNewTabRequest(e , props  ,  appContext.appReducer);
        }
        if( !e.isPropagationStopped() ){
            if( props.onClick ){
                props.onClick(e);
            }
            if( !props.checkNewTabRequestFirst ){
                handleClick(e , props ,  appContext.appReducer);
            }
        }
    };
    return   ( 
        <a {...newProps} onClick={onClick}>{ props.children }</a>
    ) ;
}

const checkNewTabRequest = (e , props , appReducer ) => {
    if( !e.isPropagationStopped() ){ // user defined onclick kan propagation al gestopt hebben.
        if( props.href &&   (e.ctrlKey || e.metaKey)){
            e.stopPropagation();
        }  
    }  
};

const handleClick = (e , props , appReducer ) => {
    if( !e.isPropagationStopped() ){ // user defined onclick kan propagation al gestopt hebben.
        if( props.href &&   !(e.ctrlKey || e.metaKey)){
            e.preventDefault(); 
            appReducer.loadPageByResourcePath(props.href);
        }   
    }  
};

export default Anchor ;
 